import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { errorMessage, post } from "../api";
import { useSession } from "../session";
import { cx } from "./ui";

const pill = "rounded-full border border-line bg-white px-3.5 py-1.5 text-sm font-semibold text-ink-soft hover:border-brand hover:text-brand disabled:opacity-60";

/**
 * Sending an address somewhere: on a phone, the share sheet (pick the Rivian app, Messages...); on a
 * computer, copy it. And for the Rivian's owner, straight to the truck.
 */
export function AddressActions({ address, jobId = null, contactId = null }: { address: string; jobId?: string | null; contactId?: string | null }) {
  const { me } = useSession();
  const [note, setNote] = useState<{ ok: boolean; text: string } | null>(null);
  const truck = useMutation({
    mutationFn: () => post<{ message: string }>("/api/rivian/destination", { address, jobId, contactId }),
    onSuccess: () => setNote({ ok: true, text: "Sent to the Rivian." }),
    onError: (e) => setNote({ ok: false, text: errorMessage(e) }),
  });
  const phone = typeof navigator.share === "function" && window.matchMedia("(pointer: coarse)").matches;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setNote({ ok: true, text: "Address copied." });
    } catch {
      setNote({ ok: false, text: address });
    }
  };
  return (
    <>
      <button type="button" className={pill} onClick={() => (phone ? navigator.share({ text: address }).catch(() => undefined) : copy())}>
        {phone ? "Send address" : "Copy address"}
      </button>
      {me?.rivian && (
        <button type="button" className={pill} disabled={truck.isPending} onClick={() => (setNote(null), truck.mutate())}>
          {truck.isPending ? "Sending…" : "Send to Rivian"}
        </button>
      )}
      {note && <span className={cx("self-center text-sm", note.ok ? "text-ok" : "text-danger")}>{note.text}</span>}
    </>
  );
}
